import { render, staticRenderFns } from "./TestTry3.vue?vue&type=template&id=19d3aca2"
import script from "./TestTry3.vue?vue&type=script&lang=js"
export * from "./TestTry3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports